import { WidgetType } from '../../../types/WidgetType';
import { ModelWidgetData } from '../types';

import { sanitiseAiredaleStringParam } from './sanitiseAiredaleStringParam';

const WIDGETS_THAT_NEED_AIREDALE_DATA = [
  WidgetType.EAGLE,
  WidgetType.TILE,
  WidgetType.SCROLLABLE_TILE,
];

export const enrichModelWidgetWithAiredaleInfo = async (
  setupModelWidgetData: ModelWidgetData,
): Promise<ModelWidgetData> => {
  const doesNotNeedAiredaleData = !WIDGETS_THAT_NEED_AIREDALE_DATA.includes(
    setupModelWidgetData.options.props.widgetType,
  );
  const isMerchantPage = setupModelWidgetData.options.props.params.article_type === 'voucher';
  if (doesNotNeedAiredaleData || isMerchantPage) {
    return setupModelWidgetData;
  }

  const retailers = [
    ...new Set(
      setupModelWidgetData.model.tabConfigs
        .map((tab) => {
          return setupModelWidgetData.model.tabData[tab.value].offers.map((offer) => {
            if (offer.merchant.name) {
              return sanitiseAiredaleStringParam(offer.merchant.name);
            }
            return offer.merchant.name;
          });
        })
        .flat(),
    ),
  ];

  if (!retailers.length) {
    return setupModelWidgetData;
  }

  const MIN_AIREDALE_RESULTS = 100;
  const MAX_AIREDALE_RESULTS = retailers.length * 3;

  const airedaleResponse = await setupModelWidgetData.options.props.getAiredaleFeeds({
    site: setupModelWidgetData.options.props.site.id,
    length: Math.max(MIN_AIREDALE_RESULTS, MAX_AIREDALE_RESULTS),
    retailerCategory: retailers.join(','),
    territory:
      setupModelWidgetData.options.props.params.area ??
      setupModelWidgetData.options.props.territory,
  });

  return {
    ...setupModelWidgetData,
    model: {
      ...setupModelWidgetData.model,
      tabData: {
        ...setupModelWidgetData.model.tabConfigs.reduce((acc, tab) => {
          return {
            ...acc,
            [tab.value]: {
              ...setupModelWidgetData.model.tabData[tab.value],
              offers: setupModelWidgetData.model.tabData[tab.value].offers.map((offer) => {
                return {
                  ...offer,
                  airedale_info: {
                    canonicalUrl: airedaleResponse.find(
                      (siteInfo) =>
                        siteInfo.articlevoucherretailercategory?.toLowerCase() ===
                        offer.merchant.name?.toLowerCase(),
                    )?.canonical,
                  },
                };
              }),
            },
          };
        }, {}),
      },
    },
  };
};
